import React from "react"
import { PalletStateType } from "store/production.reducer"
import {
  COMPANY_NAME,
  COMPANY_ADDRESS,
  COUNTRY,
  getProductName,
  getVariety,
  getLotCodes,
  getFarmRegNosArray,
  getGGN,
  getNetWeight,
  GRADE_CLASS,
} from "./labelHelpers"

interface LabelBoxEndProps {
  pallet: PalletStateType
  production: any
  size: string
}

export default function LabelBoxEnd({
  pallet,
  production,
  size,
}: LabelBoxEndProps) {
  const variety = getVariety(pallet)
  const productName = getProductName(pallet)
  const lotCodes = getLotCodes(pallet)
  const farmRegNos = getFarmRegNosArray(pallet)
  const ggn = getGGN(production, pallet)
  const netWeight = getNetWeight(production, pallet)

  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        color: "#000",
        background: "#fff",
        border: "1px solid #000",
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        fontWeight: 700,
        fontSize: 12,
      }}
    >
      {/* ── Company header ── */}
      <div
        style={{
          padding: "4px 8px",
          borderBottom: "1px solid #000",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: 14, marginBottom: "2px" }}>
          PACKED & EXPORTED BY:
        </div>
        <div style={{ fontSize: 14, marginBottom: "2px" }}>{COMPANY_NAME}</div>
        <div style={{ fontSize: 12, fontWeight: 600, lineHeight: 1.2 }}>
          {COMPANY_ADDRESS}
        </div>
      </div>

      {/* ROW 2 */}
      <div style={{ display: "flex", flex: 1, borderBottom: "1px solid #000" }}>
        <div
          style={{
            width: "55%",
            borderRight: "1px solid #000",
            padding: "4px 6px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Country of Origin : {COUNTRY}
        </div>
        <div style={{ width: "45%", display: "flex" }}>
          <div
            style={{
              width: "50%",
              borderRight: "1px solid #000",
              padding: "4px 6px",
              display: "flex",
              alignItems: "center",
            }}
          >
            Class {GRADE_CLASS}
          </div>
          <div
            style={{
              width: "50%",
              padding: "4px 6px",
              display: "flex",
              alignItems: "center",
            }}
          >
            Size: {size}
          </div>
        </div>
      </div>

      {/* ROW 3 */}
      <div style={{ display: "flex", flex: 1, borderBottom: "1px solid #000" }}>
        <div
          style={{
            width: "55%",
            borderRight: "1px solid #000",
            padding: "4px 6px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Name of product: {productName}
        </div>
        <div
          style={{
            width: "45%",
            padding: "4px 6px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Variety: {variety}
        </div>
      </div>

      {/* ROW 4 */}
      <div style={{ display: "flex", flex: 1, borderBottom: "1px solid #000" }}>
        <div
          style={{
            width: "55%",
            borderRight: "1px solid #000",
            padding: "4px 6px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Farm Reg. No: {farmRegNos.join(", ")}
        </div>
        <div
          style={{
            width: "45%",
            padding: "4px 6px",
            display: "flex",
            alignItems: "center",
          }}
        >
          GGN: {ggn}
        </div>
      </div>

      {/* ROW 5 */}
      <div style={{ display: "flex", flex: 1 }}>
        <div
          style={{
            width: "55%",
            borderRight: "1px solid #000",
            padding: "4px 6px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Net. Wt.: {netWeight}
        </div>
        <div
          style={{
            width: "45%",
            padding: "4px 6px",
            display: "flex",
            alignItems: "center",
          }}
        >
          Lot Code: {lotCodes.join(", ")}
        </div>
      </div>
    </div>
  )
}
